// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__39DZa","content":"RecentSearches_content__3Og_r"};